import { Theme } from '@chakra-ui/react'

export interface NucbaFontsTheme extends Partial<Theme['fonts']> {}

export const fonts: NucbaFontsTheme = {
  body: `'Poppins', sans-serif`,
}
